Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "NewPostModal2473014988",
  {"root":"NewPostModal2473014988--root","avatar":"NewPostModal2473014988--avatar","profileInfo":"NewPostModal2473014988--profileInfo","currentMemberName":"NewPostModal2473014988--currentMemberName","rceWrapper":"NewPostModal2473014988--rceWrapper","actionButtons":"NewPostModal2473014988--actionButtons","cancelButton":"NewPostModal2473014988--cancelButton","mobileHeader":"NewPostModal2473014988--mobileHeader","mobileTitle":"NewPostModal2473014988--mobileTitle"},
  "",
  8,
  "NewPostModal2473014988"
);

